import { render } from "./AbrechnungEdit.vue?vue&type=template&id=35d1dede"
import script from "./AbrechnungEdit.vue?vue&type=script&lang=js"
export * from "./AbrechnungEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__